/**
 * 最新热文
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import ShanklistComponents from '../../../../components/shanklistComponents/index';
import { classnames } from '../../../../utils/classnames';
import { rel as relText } from '../../../../utils/rel';

class hotArticleRank extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { rankList, infoTitle, infoUrl } = this.props.content;

        return (
            <div className={styles.rank_group}>
                {/* 标题 */}
                <div className={`${styles.rank_group_title} clearfix`}>
                    <i className={classnames(styles.block, 'block')} />
                    <span className={styles.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={styles.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                </div>
                {/* 新闻 */}
                <ul className={classnames(styles.rank_list, 'rank_list')}>
                    {rankList.map((item, index) => (
                        <li key={index} className={index < 3 ? styles.top : ''}>
                            <span className={styles.nb}>{index + 1}</span>
                            <a href={item.url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export { hotArticleRank };
export default hotArticleRank;
